import React, {useState, useRef} from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import endpoints, { apiRequest } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/CloseRounded';

export default function EditTagModal(props) {        
    const data = props.dialogData
    const [errors, setErrors] = useState()
    if (data == null && errors !== null) {
        setErrors(null)
    }
    const token = useSelector((state) => state.auth.token)
    
    const nameRef = useRef()
    const descriptionRef = useRef()
    
    const save = async () => {
        if (props.dialogData == null) return
        
        let res = null
        try {
            if (props.dialogData.id) {
                res = await apiRequest('put', endpoints.tags_edit, {
                    token: token,
                    id: props.dialogData.id,
                    name: nameRef.current.value,
                    description: descriptionRef.current.value,
                })
            } else {
                res = await apiRequest('post', endpoints.tags_add, {
                    token: token,
                    name: nameRef.current.value,
                    description: descriptionRef.current.value,
                })
            }
            
            props.onSave()
        } catch (err) {
            if (err.response.data.status == 'invalidate') {
                const e = err.response.data.details
                setErrors(e)
            }
        }
    }

    return (
        <Dialog open={props.dialogData ? true : false} fullWidth onClose={props.onClose}>
            <form onSubmit={(e) => {e.preventDefault()}}>
                <DialogTitle>
                    Tag Properties
                    <IconButton
                        onClick={props.onClose}
                        sx={{
                          position: 'absolute',
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth 
                            name="name" 
                            label="Name" 
                            variant="filled" 
                            helperText={errors?.name}
                            error={errors?.name}
                            defaultValue={data?.name}
                            inputRef={nameRef}
                        />
                        <TextField
                            fullWidth 
                            name="description" 
                            label="Description" 
                            variant="filled"
                            multiline
                            rows={4}
                            helperText={errors?.description}
                            error={errors?.description}
                            defaultValue={data?.description}
                            inputRef={descriptionRef}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button type="submit" onClick={save}>Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}